export const SEARCH_CATALOG_FIELDS =
  "id,title,handle,description,thumbnail,*images"
